'use client';
import { useEffect } from 'react';
import Script from 'next/script';
import Header from "@/components/header/header";
import Footer from "@/components/footer/footer";
import DestinationPackages from '@/components/DestinationPackages';
import Head from "next/head";


export default function HomePage() {
  useEffect(() => {
    // Initialize dataLayer if it doesn't exist
    window.dataLayer = window.dataLayer || [];
  }, []);

  return (
    <>
     
      {/* Google Tag Manager Script */}
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-W7KN8667');
          `,
        }}
      />

      {/* Google Tag Manager (noscript) */}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-W7KN8667"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>

      <Header />

      {/* Responsive Hero Section */}
      <div
        className="hero-section d-flex flex-column justify-content-center align-items-center text-center"
        style={{
          position: 'relative',
          minHeight: '80vh',
          background: `
            linear-gradient(135deg, rgba(11, 72, 120, 0.9) 0%, rgba(26, 90, 138, 0.85) 50%, rgba(44, 107, 160, 0.8) 100%),
            url('https://trip.saishishirtours.in/wp-content/uploads/2025/09/miniature-tropical-oasis-with-serene-pool-lush-greenery-peaceful-surroundings-offering-scaled.webp')
          `,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: 'white',
          overflow: 'hidden'
        }}
      >
        {/* Mobile Decorative Elements (Small, positioned carefully) */}
        <div className="d-block d-sm-none">
          {/* Top left - Small circle */}
          <div 
            className="floating-element mobile-element"
            style={{
              position: 'absolute',
              top: '20%',
              left: '5%',
              width: '45px',
              height: '45px',
              borderRadius: '50%',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/08/giraffes-zoo-scaled.webp') center/cover`,
              border: '2px solid rgba(255, 159, 38, 0.8)',
              boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
              animation: 'float 6s ease-in-out infinite',
              zIndex: 1
            }}
          >
            <div className="destination-label mobile"></div>
          </div>

          {/* Top right - Small square */}
          <div 
            className="floating-element mobile-element"
            style={{
              position: 'absolute',
              top: '18%',
              right: '8%',
              width: '40px',
              height: '40px',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/07/Singapore-banner-3-scaled.jpg') center/cover`,
              border: '2px solid rgba(255, 159, 38, 0.8)',
              borderRadius: '8px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
              animation: 'float 8s ease-in-out infinite reverse',
              zIndex: 1
            }}
          >
            <div className="destination-label mobile"></div>
          </div>

          {/* Left middle - Small circle */}
          <div 
            className="floating-element mobile-element"
            style={{
              position: 'absolute',
              top: '72%',
              left: '3%',
              width: '42px',
              height: '42px',
              borderRadius: '50%',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/08/Srilanka-SQ-2.webp') center/cover`,
              border: '2px solid rgba(255, 159, 38, 0.8)',
              boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
              animation: 'float 7s ease-in-out infinite',
              zIndex: 1
            }}
          >
            <div className="destination-label mobile"></div>
          </div>

          {/* Right middle - Small square */}
          <div 
            className="floating-element mobile-element"
            style={{
              position: 'absolute',
              top: '65%',
              right: '6%',
              width: '45px',
              height: '45px',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/07/futuristic-dubai-landscape-scaled.webp') center/cover`,
              border: '2px solid rgba(255, 159, 38, 0.8)',
              borderRadius: '8px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
              animation: 'float 9s ease-in-out infinite',
              zIndex: 1
            }}
          >
            <div className="destination-label mobile"></div>
          </div>
        </div>

        {/* Small Mobile (iPhone SE, etc.) - Even smaller elements */}
        <div className="d-block" style={{ display: 'none' }}>
          
        </div>

        {/* Tablet Decorative Elements (Medium size) */}
        <div className="d-none d-sm-block d-lg-none">
          <div 
            className="floating-element"
            style={{
              position: 'absolute',
              top: '10%',
              left: '8%',
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/08/giraffes-zoo-scaled.webp') center/cover`,
              border: '3px solid rgba(255, 159, 38, 0.8)',
              boxShadow: '0 6px 20px rgba(0,0,0,0.3)',
              animation: 'float 6s ease-in-out infinite',
              zIndex: 1
            }}
          >
            <div className="destination-label small">PhuQuoc</div>
          </div>

          <div 
            className="floating-element"
            style={{
              position: 'absolute',
              top: '20%',
              right: '10%',
              width: '55px',
              height: '55px',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/07/futuristic-dubai-landscape-scaled.webp') center/cover`,
              border: '3px solid rgba(255, 159, 38, 0.8)',
              borderRadius: '10px',
              boxShadow: '0 6px 20px rgba(0,0,0,0.3)',
              animation: 'float 8s ease-in-out infinite reverse',
              zIndex: 1
            }}
          >
            <div className="destination-label small">Dubai</div>
          </div>

          <div 
            className="floating-element"
            style={{
              position: 'absolute',
              bottom: '30%',
              left: '5%',
              width: '58px',
              height: '58px',
              borderRadius: '50%',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/07/bali-creative-scaled.webp') center/cover`,
              border: '3px solid rgba(255, 159, 38, 0.8)',
              boxShadow: '0 6px 20px rgba(0,0,0,0.3)',
              animation: 'float 7s ease-in-out infinite',
              zIndex: 1
            }}
          >
            <div className="destination-label small">Bali</div>
          </div>

          <div 
            className="floating-element"
            style={{
              position: 'absolute',
              bottom: '35%',
              right: '8%',
              width: '52px',
              height: '52px',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/07/merlion-park-singapore-scaled.webp') center/cover`,
              border: '3px solid rgba(255, 159, 38, 0.8)',
              transform: 'rotate(45deg)',
              boxShadow: '0 6px 20px rgba(0,0,0,0.3)',
              animation: 'float 6.5s ease-in-out infinite',
              zIndex: 1
            }}
          >
            <div className="destination-label diamond small">Singapore</div>
          </div>
        </div>

        {/* Large Tablet / Small Desktop */}
        <div className="d-none d-lg-block d-xl-none">
          <div 
            className="floating-element"
            style={{
              position: 'absolute',
              top: '20%',
              left: '8%',
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/08/giraffes-zoo-scaled.webp') center/cover`,
              border: '3px solid rgba(255, 159, 38, 0.8)',
              boxShadow: '0 6px 20px rgba(0,0,0,0.3)',
              animation: 'float 6s ease-in-out infinite',
              zIndex: 1
            }}
          >
            <div className="destination-label small">PhuQuoc</div>
          </div>

          <div 
            className="floating-element"
            style={{
              position: 'absolute',
              top: '20%',
              right: '10%',
              width: '70px',
              height: '70px',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/07/futuristic-dubai-landscape-scaled.webp') center/cover`,
              border: '3px solid rgba(255, 159, 38, 0.8)',
              borderRadius: '12px',
              boxShadow: '0 6px 20px rgba(0,0,0,0.3)',
              animation: 'float 8s ease-in-out infinite reverse',
              zIndex: 1
            }}
          >
            <div className="destination-label small">Dubai</div>
          </div>

          <div 
            className="floating-element"
            style={{
              position: 'absolute',
              bottom: '30%',
              left: '5%',
              width: '75px',
              height: '75px',
              borderRadius: '50%',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/07/bali-creative-scaled.webp') center/cover`,
              border: '3px solid rgba(255, 159, 38, 0.8)',
              boxShadow: '0 6px 20px rgba(0,0,0,0.3)',
              animation: 'float 7s ease-in-out infinite',
              zIndex: 1
            }}
          >
            <div className="destination-label small">Bali</div>
          </div>

          <div 
            className="floating-element"
            style={{
              position: 'absolute',
              top: '45%',
              right: '4%',
              width: '65px',
              height: '65px',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/07/Singapore-banner-3-scaled.jpg') center/cover`,
              border: '3px solid rgba(255, 159, 38, 0.8)',
              borderRadius: '12px',
              boxShadow: '0 6px 20px rgba(0,0,0,0.3)',
              animation: 'float 9s ease-in-out infinite',
              zIndex: 1
            }}
          >
            <div className="destination-label small">Malaysia</div>
          </div>

          <div 
            className="floating-element"
            style={{
              position: 'absolute',
              bottom: '25%',
              right: '12%',
              width: '68px',
              height: '68px',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/07/merlion-park-singapore-scaled.webp') center/cover`,
              border: '3px solid rgba(255, 159, 38, 0.8)',
              transform: 'rotate(45deg)',
              boxShadow: '0 6px 20px rgba(0,0,0,0.3)',
              animation: 'float 6.5s ease-in-out infinite',
              zIndex: 1
            }}
          >
            <div className="destination-label diamond small">Singapore</div>
          </div>
        </div>

        {/* Desktop Decorative Elements (Full size) */}
        <div className="d-none d-xl-block">
          {/* PhuQuoc - Circle */}
          <div 
            className="floating-element"
            style={{
              position: 'absolute',
              top: '12%',
              left: '5%',
              width: '120px',
              height: '120px',
              borderRadius: '50%',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/08/giraffes-zoo-scaled.webp') center/cover`,
              border: '4px solid rgba(255, 159, 38, 0.8)',
              boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
              animation: 'float 6s ease-in-out infinite',
              zIndex: 1
            }}
          >
            <div className="destination-label">PhuQuoc</div>
          </div>

          {/* Malasia - Square */}
          <div 
            className="floating-element"
            style={{
              position: 'absolute',
              top: '15%',
              right: '8%',
              width: '100px',
              height: '100px',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/07/Singapore-banner-3-scaled.jpg') center/cover`,
              border: '4px solid rgba(255, 159, 38, 0.8)',
              borderRadius: '15px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
              animation: 'float 8s ease-in-out infinite reverse',
              zIndex: 1
            }}
          >
            <div className="destination-label">Malaysia</div>
          </div>

          {/* SriLanka - Circle */}
          <div 
            className="floating-element"
            style={{
              position: 'absolute',
              bottom: '25%',
              left: '3%',
              width: '110px',
              height: '110px',
              borderRadius: '50%',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/08/Srilanka-SQ-2.webp') center/cover`,
              border: '4px solid rgba(255, 159, 38, 0.8)',
              boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
              animation: 'float 7s ease-in-out infinite',
              zIndex: 1
            }}
          >
            <div className="destination-label">SriLanka</div>
          </div>

          {/* Dubai - Square */}
          <div 
            className="floating-element"
            style={{
              position: 'absolute',
              top: '45%',
              right: '4%',
              width: '90px',
              height: '90px',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/07/futuristic-dubai-landscape-scaled.webp') center/cover`,
              border: '4px solid rgba(255, 159, 38, 0.8)',
              borderRadius: '15px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
              animation: 'float 9s ease-in-out infinite',
              zIndex: 1
            }}
          >
            <div className="destination-label">Dubai</div>
          </div>

          {/* Bali - Circle */}
          <div 
            className="floating-element"
            style={{
              position: 'absolute',
              top: '35%',
              left: '10%',
              width: '85px',
              height: '85px',
              borderRadius: '50%',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/07/bali-creative-scaled.webp') center/cover`,
              border: '3px solid rgba(255, 159, 38, 0.8)',
              boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
              animation: 'float 5s ease-in-out infinite reverse',
              zIndex: 1
            }}
          >
            <div className="destination-label">Bali</div>
          </div>

          {/* Singapore - Diamond */}
          <div 
            className="floating-element"
            style={{
              position: 'absolute',
              bottom: '25%',
              right: '12%',
              width: '80px',
              height: '80px',
              background: `url('https://trip.saishishirtours.in/wp-content/uploads/2025/07/merlion-park-singapore-scaled.webp') center/cover`,
              border: '3px solid rgba(255, 159, 38, 0.8)',
              transform: 'rotate(45deg)',
              boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
              animation: 'float 6.5s ease-in-out infinite',
              zIndex: 1
            }}
          >
            <div className="destination-label ">Singapore</div>
          </div>
        </div>

        {/* Main Content */}
        <div className="container mt-3 mt-md-5 px-3 px-md-4" style={{ zIndex: 2 }}>
          {/* Main Heading */}
          <div className="mb-3 mb-md-5">
  <h1 className="display-6  fw-bold mb-2" style={{ 
    fontSize: 'clamp(1.7rem, 4vw, 4rem)',
    lineHeight: '1.2',
    textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
  }}>
   From Bangalore to the World,
  </h1>
  <h1 className="display-6 fw-bold mb-3 mb-md-4" style={{ 
    fontSize: 'clamp(1.7rem, 4vw, 4rem)',
    lineHeight: '1.3',
    textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
  }}>
    Tours Made Easy With  <br className=""/> <span style={{ color: '#ff9f26' }}>Sai Shishir Tours.</span>
  </h1>
</div>

          {/* Features Row - Mobile Optimized */}
          <div className='container w-75 w-md-75'>
            <div className="row justify-content-center mb-4 mb-md-5 g-2 g-md-4">
              {/* Feature Item */}
              <div className="col-6 col-sm-6 col-lg-3">
                <div className="d-flex align-items-center justify-content-center justify-content-sm-start">
                  <div
                    className="d-flex align-items-center justify-content-center orange-brand-color bg-blue-brand rounded-circle me-2"
                    style={{ 
                      width: "35px", 
                      height: "35px", 
                      flexShrink: 0,
                      fontSize: "0.9rem"
                    }}
                  >
                    <i className="bi bi-headset"></i>
                  </div>
                  <div className="feature-text">
                    <div className="fw-bold text-warning">24/7</div>
                    <div className="text-white small ">Support</div>
                  </div>
                </div>
              </div>

              {/* Feature Item */}
              <div className="col-6 col-sm-6 col-lg-3">
                <div className="d-flex align-items-center justify-content-center justify-content-sm-start">
                  <div
                    className="d-flex align-items-center justify-content-center orange-brand-color bg-blue-brand rounded-circle me-2"
                    style={{ 
                      width: "35px", 
                      height: "35px", 
                      flexShrink: 0,
                      fontSize: "0.9rem"
                    }}
                  >
                    <i className="bi bi-calendar-check"></i>
                  </div>
                  <div className="feature-text">
                    <div className="fw-bold text-warning">Seamless</div>
                    <div className="text-white small ">Booking</div>
                  </div>
                </div>
              </div>

              {/* Feature Item */}
              <div className="col-6 col-sm-6 col-lg-3">
                <div className="d-flex align-items-center justify-content-center justify-content-sm-start">
                  <div
                    className="d-flex align-items-center justify-content-center orange-brand-color bg-blue-brand rounded-circle me-2"
                    style={{ 
                      width: "35px", 
                      height: "35px", 
                      flexShrink: 0,
                      fontSize: "0.9rem"
                    }}
                  >
                    <i className="bi bi-star-fill"></i>
                  </div>
                  <div className="feature-text">
                    <div className="fw-bold text-warning">3k★</div>
                    <div className="text-white small ">Rated</div>
                  </div>
                </div>
              </div>

              {/* Feature Item */}
              <div className="col-6 col-sm-6 col-lg-3">
                <div className="d-flex align-items-center justify-content-center justify-content-sm-start">
                  <div
                    className="d-flex align-items-center justify-content-center orange-brand-color bg-blue-brand rounded-circle me-2"
                    style={{ 
                      width: "35px", 
                      height: "35px", 
                      flexShrink: 0,
                      fontSize: "0.9rem"
                    }}
                  >
                    <i className="bi bi-globe"></i>
                  </div>
                  <div className="feature-text">
                    <div className="fw-bold text-warning">15+</div>
                    <div className="text-white small ">Countries</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Buttons - Mobile Optimized */}
          <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center align-items-center">
            <a
              href="#destinations"
              className="btn btn-lg px-4 px-md-5 py-3 fw-semibold"
              style={{
                backgroundColor: '#ff9f26',
                color: '#0b4878',
                border: 'none',
                borderRadius: '50px',
                fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
                transition: 'transform 0.3s ease',
                boxShadow: '0 6px 20px rgba(0,0,0,0.2)',
                width: '100%',
                maxWidth: '280px'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
              onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
            >
              Explore Destinations
            </a>
          </div>

         
        </div>

        {/* Enhanced CSS Animations and Mobile Responsive Styles */}
        <style jsx>{`
          .destination-label {
            position: absolute;
            bottom: -12px;
            left: 50%;
            transform: translateX(-50%);
            background: rgba(255, 159, 38, 0.95);
            color: #0b4878;
            padding: 4px 12px;
            border-radius: 15px;
            font-size: 12px;
            font-weight: bold;
            white-space: nowrap;
            backdrop-filter: blur(10px);
          }

          .destination-label.small {
            font-size: 10px;
            padding: 3px 8px;
            bottom: -10px;
          }

          .destination-label.mobile {
            font-size: 8px;
            padding: 2px 6px;
            bottom: -8px;
            border-radius: 10px;
          }

          .destination-label.diamond {
            transform: translateX(-50%) rotate(-45deg);
            bottom: -20px;
          }

          .destination-label.diamond.small {
            bottom: -15px;
          }

          .feature-text {
            font-size: 0.85rem;
            text-align: center;
          }

          @media (min-width: 576px) {
            .feature-text {
              font-size: 0.9rem;
              text-align: left;
            }
          }

          @media (min-width: 768px) {
            .feature-text {
              font-size: 1rem;
            }
          }
          @media (max-width: 375px) {
              .d-block { display: block !important; }
              .mobile-element {
                width: 35px !important;
                height: 35px !important;
              }
              .destination-label.mobile {
                font-size: 7px !important;
                padding: 2px 4px !important;
                bottom: -8px !important;
              }
            }
          /* Mobile floating elements optimization */
          @media (max-width: 575.98px) {
            .floating-element.mobile-element {
              opacity: 0.9;
              animation-duration: 8s;
            }
            
            .hero-section {
              background-attachment: scroll !important;
              padding-top: 80px;
            }
            
            .container {
              padding-left: 15px;
              padding-right: 15px;
            }
          }

          /* Very small mobile devices */
          @media (max-width: 375px) {
            .floating-element.mobile-element {
              width: 32px !important;
              height: 32px !important;
              border-width: 2px;
            }
            
            .destination-label.mobile {
              font-size: 7px !important;
              padding: 1px 4px !important;
              bottom: -6px !important;
            }
            
            .hero-section h1 {
              font-size: 1.4rem !important;
            }
            
            .feature-text {
              font-size: 0.75rem !important;
            }
          }

          /* iPhone 12/13 Pro Max and similar */
          @media (max-width: 428px) and (min-width: 376px) {
            .floating-element.mobile-element {
              width: 40px !important;
              height: 40px !important;
            }
            
            .destination-label.mobile {
              font-size: 8px !important;
              padding: 2px 5px !important;
            }
          }

          /* Tablet portrait adjustments */
          @media (min-width: 576px) and (max-width: 991.98px) {
            .floating-element {
              opacity: 0.85;
              animation-duration: 7s;
            }
          }

          /* Animation keyframes */
          @keyframes float {
            0%, 100% { 
              transform: translateY(0px) scale(1); 
            }
            50% { 
              transform: translateY(-20px) scale(1.05); 
            }
          }
          
          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.1); }
          }
          
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
            40% { transform: translateY(-10px); }
            60% { transform: translateY(-5px); }
          }
          
          @keyframes scroll {
            0% { transform: translateX(-50%) translateY(0); opacity: 0; }
            50% { opacity: 1; }
            100% { transform: translateX(-50%) translateY(20px); opacity: 0; }
          }

          /* Smooth scrolling and performance optimizations */
          .floating-element {
            will-change: transform;
            backface-visibility: hidden;
            transform-style: preserve-3d;
          }

          /* Reduce motion for users who prefer it */
          @media (prefers-reduced-motion: reduce) {
            .floating-element {
              animation: none !important;
            }
          }

          /* Touch device optimizations */
          @media (hover: none) and (pointer: coarse) {
            .floating-element {
              animation-duration: 10s;
            }
            
            .hero-section {
              background-attachment: scroll;
            }
          }

          /* High DPI display optimizations */
          @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
            .destination-label {
              border: 0.5px solid rgba(255, 159, 38, 0.8);
            }
          }

          /* Landscape mobile orientation */
          @media (max-width: 896px) and (orientation: landscape) {
            .hero-section {
              min-height: 100vh;
              padding-top: 60px;
            }
            
            .floating-element.mobile-element {
              display: none; /* Hide on mobile landscape to avoid clutter */
            }
            
            .container {
              padding-top: 20px;
            }
          }

          /* Foldable devices */
          @media (max-width: 653px) and (min-width: 629px) {
            .floating-element {
              opacity: 0.7;
              animation-duration: 12s;
            }
          }

          /* Dark mode support */
          @media (prefers-color-scheme: dark) {
            .destination-label {
              background: rgba(255, 159, 38, 1);
              box-shadow: 0 2px 10px rgba(255, 159, 38, 0.3);
            }
          }
        `}</style>
      </div>

      {/* Destination Packages Section */}
      <div id="destinations">
        <DestinationPackages />
      </div>

      <Footer />
    </>
  );
}